export const adjustEditTokenIndexAfterRemove = (
  editTokenIndex: number | null,
  removedIndex: number
): number | null => {
  if (editTokenIndex === removedIndex) {
    return null;
  }

  if (editTokenIndex !== null && removedIndex < editTokenIndex) {
    return editTokenIndex - 1;
  }

  return editTokenIndex;
};

export const adjustEditTokenIndexAfterReorder = (
  editTokenIndex: number | null,
  fromIndex: number,
  toIndex: number
): number | null => {
  if (editTokenIndex === null) {
    return null;
  }

  if (editTokenIndex === fromIndex) {
    return toIndex;
  }

  if (fromIndex < editTokenIndex && toIndex >= editTokenIndex) {
    return editTokenIndex - 1;
  }

  if (fromIndex > editTokenIndex && toIndex <= editTokenIndex) {
    return editTokenIndex + 1;
  }

  return editTokenIndex;
};
